module.exports = __webpack_public_path__ + "static/media/icon-deals.380fc463.svg";